import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {InteractionComponentProps} from '../../../../../libs/shared/helpers/src/interaction/interactionHelpers';
import {Handler, Renderer} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {center} from '../../../../../libs/shared/ui/src/styles/mixins';
import {boxShadow} from '../../../../../libs/shared/ui/src/theme/themeStyleHelpers';
import {TooltipExplicitCondition} from '../../../common/tooltips/tooltipExplicitCondition';

/*
 * Props.
 */

export interface SwitcherItemProps extends InteractionComponentProps {
  isSelected?: boolean;
  isInMultiViewButton?: boolean;
  onClick: Handler;
  renderTooltip?: Renderer;
}

/*
 * Style.
 */

interface IconStyleProps {
  $isSelected: boolean;
  $isInMultiViewButton?: boolean;
}
const StyledItemDiv = styled.div<IconStyleProps>`
  position: relative;
  width: 30px;
  height: 30px;

  overflow: hidden;
  border-radius: 15px;
  ${center()};

  transition: transform 150ms;
  ${(p) => maybeAddSelectedStyle(p.$isSelected, p.$isInMultiViewButton)};
`;

function maybeAddSelectedStyle(isSelected: boolean, isInMultiViewButton?: boolean) {
  if (isInMultiViewButton) {
    return css`
      background-color: ${(p) => p.theme.greys.white};
    `;
  }

  if (!isSelected) {
    return css`
      &:hover {
        background-color: ${(p) => p.theme.alphas.gray10};
      }
    `;
  }

  return css`
    background-color: ${(p) => p.theme.greys.white};
    ${(p) =>
      boxShadow(
        p.theme,
        `0 2px 9px ${p.theme.alphas.black50}`,
        `border: 1px solid ${p.theme.greys.shade70}`,
      )};

    &:hover {
      transform: scale(1.1);
    }
  `;
}

const StyledChromelessButton = styled(ChromelessButton)`
  display: flex;
  justify-content: center;
`;

/*
 * Component.
 */

export const SwitcherItem: FC<SwitcherItemProps> = (props) => (
  <TooltipCoordinator render={props.renderTooltip} hideOnMouseDown>
    <TooltipExplicitCondition isEnabled={!props.isInMultiViewButton} />
    <StyledChromelessButton onClick={props.onClick} interactionId={props.interactionId}>
      <StyledItemDiv $isSelected={Boolean(props.isSelected)} $isInMultiViewButton={props.isInMultiViewButton}>
        {props.children}
      </StyledItemDiv>
    </StyledChromelessButton>
  </TooltipCoordinator>
);
